<template>
    <div style="height:100%">
        <div id="csContainer"></div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let vw = util.getViewer("csContainer");
                // this.flyAnimation(vw);
            },
            flyAnimation(viewer) {
                var entity = viewer.entities.add({

                    //Set the entity availability to the same interval as the simulation time.
                    availability: new Cesium.TimeIntervalCollection([new Cesium.TimeInterval({
                        start: start,
                        stop: stop
                    })]),

                    //Use our computed positions
                    position: position,

                    //Automatically compute orientation based on position movement.
                    orientation: new Cesium.VelocityOrientationProperty(position),

                    //Load the Cesium plane model to represent the entity
                    model: {
                        uri: '../../SampleData/models/CesiumAir/Cesium_Air.gltf',
                        minimumPixelSize: 64
                    },

                    //Show the path as a pink line sampled in 1 second increments.
                    path: {
                        resolution: 1,
                        material: new Cesium.PolylineGlowMaterialProperty({
                            glowPower: 0.1,
                            color: Cesium.Color.YELLOW
                        }),
                        width: 10
                    }
                });
            }
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
        width:100%;
    }
</style>
